export const ROLE_SELLER = 3580;
export const ROLE_BUYER = 3581;
export const ROLE_DEBTOR = 3582;
export const ROLE_ISO = 3583;
export const ROLE_CONFIRMING = 4149;
